import axios from '../../../../apis/Api'
import history, { logout } from '../../../../history'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { GET_SCR_SUMMARY_REPORT } from '../../../../Types'

export const getSCRSummaryReport = (postedData) => async (dispatch) => {
    dispatch(showLoading())
        await axios
        .post(`api/SCRReports/GetSCRSummaryReport`, postedData)
        .then(({ data }) => {

            const reportKey =
                postedData.deliveryUserId + "_" + postedData.OrderDeliveryDate;

            dispatch({
                type: GET_SCR_SUMMARY_REPORT,
                payload: {
                    key: reportKey,
                    data: data.response,
                },
            })

            dispatch(hideLoading())
        })
        .catch(function (error) {
            dispatch(hideLoading())
            if (error.response) {
                if (error.response.status === 401) {
                    logout()
                    history.push('/login')
                    history.go('/login')
                } else if (
                    error.response.status === 400 &&
                    error.response.data.errors
                ) {
                    let errorMessage = ''
                    var errors = error.response.data.errors
                    var keys = Object.keys(errors)
                    for (let j = 0; j < keys.length; j++) {
                        errorMessage += errors[keys[j]] + ' , \n'
                    }
                    toast.error(errorMessage)
                } else if (error.response.data)
                    toast.error(
                        error.response.data.Message
                            ? error.response.data.Message
                            : error.response.data.message
                    )
                else {
                    toast.error('Error while processing the request')
                }
            } else toast.error('Error while processing the request')
        })
}

export const finalizeSCRSummaryReport = (postedData) => async (dispatch) => {
    dispatch(showLoading())
    await axios
        .post(`api/SCRReports/FinalizeSCRSummaryReport`, postedData)
        .then(({ data }) => {
            if (data.isSuccess) {
                toast.success("Finalize successfully");
            }
            else {
                toast.error(data.message)
            }
            dispatch(hideLoading())
        })
        .catch(function (error) {
            dispatch(hideLoading())
            if (error.response) {
                if (error.response.status === 401) {
                    logout()
                    history.push('/login')
                    history.go('/login')
                } else if (
                    error.response.status === 400 &&
                    error.response.data.errors
                ) {
                    let errorMessage = ''
                    var errors = error.response.data.errors
                    var keys = Object.keys(errors)
                    for (let j = 0; j < keys.length; j++) {
                        errorMessage += errors[keys[j]] + ' , \n'
                    }
                    toast.error(errorMessage)
                } else if (error.response.data)
                    toast.error(
                        error.response.data.Message
                            ? error.response.data.Message
                            : error.response.data.message
                    )
                else {
                    toast.error('Error while processing the request')
                }
            } else toast.error('Error while processing the request')
        })
}